const placeholderLocales = {
    en: 'Select Time',
    'zh-hant': '選擇時間',
    'zh-cn': '选择时间',
    vi: 'chọn thời gian',
    th: 'เลือกเวลา',
};
const inputTooltipLocales = {
    en: 'Enter Format HH:mm:ss',
    'zh-hant': '輸入格式 HH:mm:ss',
    'zh-cn': '输入格式 HH:mm:ss',
    vi: 'Nhập vào định dạng HH:mm:ss',
    th: 'รูปแบบอินพุต HH:mm:ss',
};
export const getDefaultPlaceholder = (lang) => placeholderLocales[lang] || placeholderLocales.en;
export const getDefaultInputTooltip = (lang) => inputTooltipLocales[lang] || inputTooltipLocales.en;
//# sourceMappingURL=wording.js.map